import { API_ENDPOINTS } from "../api/config";

const WARMUP_INTERVAL_MS = 4 * 60 * 1000;
let lastWarmupAt = 0;
let warmupPromise = null;

export function warmBackend() {
  const now = Date.now();

  if (warmupPromise) return warmupPromise;
  if (now - lastWarmupAt < WARMUP_INTERVAL_MS) return Promise.resolve(false);

  lastWarmupAt = now;
  warmupPromise = fetch(API_ENDPOINTS.HEALTH, {
    method: "GET",
    cache: "no-store",
    keepalive: true,
  })
    .catch(() => null)
    .finally(() => {
      warmupPromise = null;
    });

  return warmupPromise;
}
